export default {
  "new-house-index-detail": () => import("/workspace/Fccs-PC-Nuxt-V3/layouts/NewHouseIndexDetail.vue").then(m => m.default || m),
  "brand-layout": () => import("/workspace/Fccs-PC-Nuxt-V3/layouts/brand-layout.vue").then(m => m.default || m),
  "floor-layout": () => import("/workspace/Fccs-PC-Nuxt-V3/layouts/floor-layout.vue").then(m => m.default || m)
}